import { render } from "./LayoutSimple.vue?vue&type=template&id=da71fdfe"
import script from "./LayoutSimple.vue?vue&type=script&lang=js"
export * from "./LayoutSimple.vue?vue&type=script&lang=js"

import "./LayoutSimple.vue?vue&type=style&index=0&id=da71fdfe&lang=less"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__